module.exports = __webpack_public_path__ + "img/lr.87cb5124.svg";